import { gql } from 'graphql-request'
export const Q_GET_SUPPORT_USERS = gql`
  query getSupportUsers($where: users_bool_exp) {
    users(where: $where) {
      id
      email
      defaultRole
      createdAt
      updatedAt
      displayName
      disabled
    }
    usersAggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`
export const Q_GET_USERS_BY_ROLES = gql`
query user{
  users(where:{roles:{role:{_in:["qcreator","papersetter","subjectincharge","paperapprover","evaluators","qapprover","qreviewer","variantcreator","evaluationincharge","productmanager"]}},disabled:{_eq:false}},order_by:{displayName:asc}){
    id
    displayName
    email
    disabled
    roles{
      role
    }
  }
}
`

export const GET_HISTORY_LOG=gql`
query logs {

audit_dependency_question_view{
  subject_details{
    name
  }
  report_theme_details{
    name
  }
  theme_details{
    name
  }
  sub_theme_details{
    name
  }
  topic_details{
    name
  }
  creator_details{
    displayName
  }
  question_details{
      title
      question_id
    }
}
}

`;